// extracted by mini-css-extract-plugin
export var chapterHero = "chapter-hero-module--chapterHero--ksbns";
export var chapterTextContainer = "chapter-hero-module--chapter-text-container--Voc7r";
export var header = "chapter-hero-module--header--JjvbG";
export var imageContainer = "chapter-hero-module--imageContainer--DZkAu";
export var innerContainer = "chapter-hero-module--innerContainer--eExnE";
export var listenContainer = "chapter-hero-module--listen-container--bzGJM";